import { Navigate, useLocation } from 'react-router-dom'
import { webinarStorage } from '@/services/webinarApi'

interface Props {
  children: React.ReactNode
}

export function WebinarProtectedRoute({ children }: Props) {
  const location = useLocation()
  const key = webinarStorage.getKey()

  if (!key) {
    return <Navigate to="/inscriptions-admin/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}
